function Directive() {
  "ngInject";
  // eslint-disable-next-line max-len
  const EMAIL_REGEXP = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return {
    require: "?ngModel",
    link(scope, elm, attrs, ctrl) {
      // Only apply the validator if ngModel is present and AngularJS has added the email validator
      if (ctrl && ctrl.$validators.email) {
        // This will overwrite the default AngularJS email validator
        ctrl.$validators.email = function (modelValue) {
          return ctrl.$isEmpty(modelValue) || EMAIL_REGEXP.test(modelValue);
        };
      }
    },
  };
}

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/validEmail/validEmail.directive.js